const FEATURES = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '人工审核保障',
    desc: '所有收录的吃瓜爆料网站均经过团队人工审核，定期复查，确保平台质量可靠、内容真实。',
  },
  {
    id: 2,
    icon: 'ri-refresh-line',
    title: '每日动态更新',
    desc: '排名榜单和平台收录每日更新，实时反映各吃瓜爆料网站的最新状态，确保信息时效性。',
  },
  {
    id: 3,
    icon: 'ri-layout-grid-line',
    title: '清晰分类导航',
    desc: '按娱乐圈、网红圈、综艺、电竞等主题精细分类，让你快速定位感兴趣的吃瓜爆料网站类型。',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '全平台适配',
    desc: '桌面端、平板、手机全设备完美适配，无论使用什么设备都能获得流畅的吃瓜导航体验。',
  },
  {
    id: 5,
    icon: 'ri-user-heart-line',
    title: '用户驱动推荐',
    desc: '接受用户推荐新的吃瓜爆料网站，共同建设更全面的吃瓜导航生态，好平台由大家发现。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
            吃瓜爆料网的核心优势，让你放心使用
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {FEATURES.map((feature, idx) => (
            <div
              key={feature.id}
              className={`group p-6 md:p-7 rounded-xl border transition-all cursor-pointer ${
                idx === 0 ? 'bg-primary-50/50 border-primary-200/50 hover:border-primary-300' :
                idx === 1 ? 'bg-accent-50/50 border-accent-200/50 hover:border-accent-300' :
                idx === 2 ? 'bg-secondary-50/50 border-secondary-200/50 hover:border-secondary-300' :
                'bg-background-100 border-background-200/60 hover:border-background-300'
              }`}
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${
                idx === 0 ? 'bg-primary-100 text-primary-600' :
                idx === 1 ? 'bg-accent-100 text-accent-600' :
                idx === 2 ? 'bg-secondary-100 text-secondary-600' :
                'bg-background-200 text-foreground-600'
              }`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}